module.exports = __webpack_public_path__ + "static/tat-8-0019652c7212d1606437b237b3a9b619.jpg";